import { IAuthClient } from "@multiweb/clients/auth";
import { isVersionOlderOrEqual } from "Global/Base/Utils/versionUtils";
import { ICommunicationManager } from "OW.Remoting/Remoting/ICommunicationManager";
import { ASAuthClient } from "./ASAuthClient";

export function defaultFactory(communicationManager: ICommunicationManager, webServiceUrl: string, webServiceVersion?: string): IAuthClient {
    return new ASAuthClient(communicationManager, webServiceUrl, isVersionOlderOrEqual(webServiceVersion, "15.03"));
}

export { ASAuthClient };
